export const WorkoutSection = {
  bindings: {
    workout: '<',
    section: '<',
    exercises: '<',
    params: '<',
    gender: '<',
    onShowModal: '&',
  },

  template: `
    <div class="card card-workout mb-5 mb-sm-4"
      ng-class="{ 'card-workout-stretch': $ctrl.section.name == 'Stretch' }"
      ng-if="$ctrl.section.name != 'Transition'">
      <h3 class="card-header d-flex align-items-center">
        {{ $ctrl.section.name }}
        <small class="label ml-auto text-gray"
          ng-show="$ctrl.section.totalTimeSet">
          <i class="fa fa-lg icon-time text-green-dark"></i>
          {{ $ctrl.section.totalTimeMinutes }}
        </small>
      </h3>
      <div class="card-block pt-4 pb-0 pl-sm-4 pr-sm-0">
        <p class="note"
          ng-show="$ctrl.section.note"
          ng-bind-html="$ctrl.section.note">
        </p>
        <div class="exercise-container w-100"
          ng-repeat="item in $ctrl.section.items track by $index"
          ng-if="item.name !== 'Transition'">
          <div class="exercise-pad" ng-if="item.exerciseId">
            <exercise
              index="$index"
              data="item"
              workout="$ctrl.workout"
              exercise="$ctrl.exercises[item.exerciseId]"
              gender="$ctrl.gender"
              params="$ctrl.params"
              on-click="$ctrl.onShowModal({ item: item })">
            </exercise>
          </div>
          <exercise-set
            data="item"
            workout="$ctrl.workout"
            exercises="$ctrl.exercises"
            gender="$ctrl.gender"
            params="$ctrl.params"
            on-show-modal="$ctrl.onShowModal({ item: item })"
            ng-if="!item.exerciseId">
          </exercise-set>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Workout/WorkoutSection.js